import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { TrackProvider } from './contexts/TrackContext';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingTrackSelector from './components/FloatingTrackSelector';
import SubscriptionUpgradeNotification from './components/SubscriptionUpgradeNotification';
import LandingPage from './pages/LandingPage';
import Case1Page from './pages/Case1Page';
import Case2Page from './pages/Case2Page';
import Case3Page from './pages/Case3Page';
import Case4Page from './pages/Case4Page';
import Case5Page from './pages/Case5Page';
import Case6Page from './pages/Case6Page';
import Case7Page from './pages/Case7Page';
import Case8Page from './pages/Case8Page';
import Case9Page from './pages/Case9Page';
import Case10Page from './pages/Case10Page';
import Case11Page from './pages/Case11Page';
import Case12Page from './pages/Case12Page';
import Case13Page from './pages/Case13Page';
import Case14Page from './pages/Case14Page';
import Case15Page from './pages/Case15Page';
import Case16Page from './pages/Case16Page';
import Case17Page from './pages/Case17Page';
import RedRockPage from './pages/RedRockPage';
import RedRockGuidePage from './pages/RedRockGuidePage';
import RedRockAppPage from './pages/RedRockAppPage';
import EcosystemSolverPage from './pages/EcosystemSolverPage';
import AboutSolvePage from './pages/AboutSolvePage';
import AboutBcgCaseyPage from './pages/AboutBcgCaseyPage';
import AboutPage from './pages/AboutPage';
import ConsultingMathGuidesPage from './pages/ConsultingMathGuidesPage';
import SeaWolfPage from './pages/SeaWolfPage';
import SeaWolfPracticePage from './pages/SeaWolfPracticePage';
import SeaWolfAppPage from './pages/SeaWolfAppPage';
import TryForFreePage from './pages/TryForFreePage';
import AuthPage from './pages/AuthPage';
import CheckoutPage from './pages/CheckoutPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import PromoClaimPage from './pages/PromoClaimPage';
import EcosystemGuide from './pages/EcosystemGuide';
import McKinseyLilliAICoachPage from './pages/McKinseyLilliAICoachPage';
import BCGAICoachPage from './pages/BCGAICoachPage';
import BCGCaseySimulationPage from './pages/BCGCaseySimulationPage';
import BCGCaseyAppPage from './pages/BCGCaseyAppPage';
import BCGCaseyGuidePage from './pages/BCGCaseyGuidePage';
import AccountPage from './pages/AccountPage';
import TermsOfUsePage from './pages/legal/TermsOfUsePage';
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';
import RefundPolicyPage from './pages/legal/RefundPolicyPage';
import ContactPage from './pages/legal/ContactPage';
import InternalReviewsPage from './pages/InternalReviewsPage';
import { FeatureTestPage } from './pages/FeatureTestPage';
import { FeatureAccessTestPage } from './pages/FeatureAccessTestPage';
import { FeatureAccessGate } from './components/FeatureAccessGate';
import DemoEcosystemSolverPage from './pages/DemoEcosystemSolverPage';
import ProtectedRoute from './components/ProtectedRoute';
import PremiumProductRouteGate from './components/PremiumProductRouteGate';
import OwnerOnlyRoute from './components/OwnerOnlyRoute';
import { PREMIUM_PRODUCT_KEYS } from './config/premiumProducts';
import NotFoundPage from './pages/NotFoundPage';
// import UnifiedOcrTest from './components/MistralTest';
import './App.css';

// ScrollToTop component to handle automatic scrolling
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <TrackProvider>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Header />
          <SubscriptionUpgradeNotification />
          <FloatingTrackSelector />
          <main className="flex-grow">
          <div className="flex flex-row justify-center items-start gap-12">
            {/* <UnifiedOcrTest /> */}
          </div>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/try-for-free" element={<TryForFreePage />} />
            <Route path="/demo-ecosystem-solver" element={<DemoEcosystemSolverPage />} />
            <Route path="/case1" element={<Case1Page />} />
            <Route path="/case2" element={
              <FeatureAccessGate feature="case2">
                <Case2Page />
              </FeatureAccessGate>
            } />
            <Route path="/case3" element={
              <FeatureAccessGate feature="case3">
                <Case3Page />
              </FeatureAccessGate>
            } />
            <Route path="/case4" element={
              <FeatureAccessGate feature="case4">
                <Case4Page />
              </FeatureAccessGate>
            } />
            <Route path="/case5" element={
              <FeatureAccessGate feature="case5">
                <Case5Page />
              </FeatureAccessGate>
            } />
            <Route path="/case6" element={
              <FeatureAccessGate feature="case6">
                <Case6Page />
              </FeatureAccessGate>
            } />
            <Route path="/case7" element={
              <FeatureAccessGate feature="case7">
                <Case7Page />
              </FeatureAccessGate>
            } />
            <Route path="/case8" element={
              <FeatureAccessGate feature="case8">
                <Case8Page />
              </FeatureAccessGate>
            } />
            <Route path="/case9" element={
              <FeatureAccessGate feature="case9">
                <Case9Page />
              </FeatureAccessGate>
            } />
            <Route path="/case10" element={
              <FeatureAccessGate feature="case10">
                <Case10Page />
              </FeatureAccessGate>
            } />
            <Route path="/case11" element={
              <FeatureAccessGate feature="case11">
                <Case11Page />
              </FeatureAccessGate>
            } />
            <Route path="/case12" element={
              <FeatureAccessGate feature="case12">
                <Case12Page />
              </FeatureAccessGate>
            } />
            <Route path="/case13" element={
              <FeatureAccessGate feature="case13">
                <Case13Page />
              </FeatureAccessGate>
            } />
            <Route path="/case14" element={
              <FeatureAccessGate feature="case14">
                <Case14Page />
              </FeatureAccessGate>
            } />
            <Route path="/case15" element={
              <FeatureAccessGate feature="case15">
                <Case15Page />
              </FeatureAccessGate>
            } />
            <Route path="/case16" element={
              <FeatureAccessGate feature="case16">
                <Case16Page />
              </FeatureAccessGate>
            } />
            <Route path="/case17" element={
              <FeatureAccessGate feature="case17">
                <Case17Page />
              </FeatureAccessGate>
            } />
            <Route path="/redrock" element={<RedRockPage />} />
            <Route path="/redrock-app/*" element={
              <PremiumProductRouteGate productKey={PREMIUM_PRODUCT_KEYS.redRockSimulation}>
                <RedRockAppPage />
              </PremiumProductRouteGate>
            } />
            <Route path="/redrock-guide" element={<RedRockGuidePage />} />
            <Route path="/ecosystem-solver" element={<EcosystemSolverPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/terms-of-use" element={<TermsOfUsePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about-solve" element={<AboutSolvePage />} />
            <Route path="/about-bcg-casey" element={<AboutBcgCaseyPage />} />
            <Route path="/consulting-math-guides" element={<ConsultingMathGuidesPage />} />
            <Route path="/seawolf" element={<SeaWolfPage />} />
            <Route path="/seawolf-practice" element={<SeaWolfPracticePage />} />
            <Route path="/seawolf-app" element={
              <PremiumProductRouteGate productKey={PREMIUM_PRODUCT_KEYS.seaWolfSimulation}>
                <SeaWolfAppPage />
              </PremiumProductRouteGate>
            } />
            <Route path="/ecosystemguide" element={<EcosystemGuide />} />
            <Route path="/mckinsey-ai-coach" element={<McKinseyLilliAICoachPage />} />
            <Route path="/mckinsey-lilli-ai-coach" element={<Navigate to="/mckinsey-ai-coach" replace />} />
            <Route path="/bcg-ai-coach" element={<BCGAICoachPage />} />
            <Route path="/casey-ai-interviewer" element={<Navigate to="/bcg-ai-coach" replace />} />
            <Route path="/bcg-casey-simulation" element={<BCGCaseySimulationPage />} />
            <Route path="/bcg-casey-app" element={
              <PremiumProductRouteGate productKey={PREMIUM_PRODUCT_KEYS.caseySimulation}>
                <BCGCaseyAppPage />
              </PremiumProductRouteGate>
            } />
            <Route path="/bcg-casey-guide" element={<BCGCaseyGuidePage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/internal/reviews" element={
              <OwnerOnlyRoute>
                <InternalReviewsPage />
              </OwnerOnlyRoute>
            } />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/basic" element={<Navigate to="/checkout?plan_id=solve_assessment&billing_term=six_month" replace />} />
            <Route path="/checkout/pro" element={<Navigate to="/checkout?plan_id=all_access&billing_term=six_month" replace />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/payment-cancel" element={<PaymentCancelPage />} />
            <Route path="/promo/:slug" element={<PromoClaimPage />} />
            <Route path="/feature-test" element={<FeatureTestPage />} />
            <Route path="/feature-access-test" element={<FeatureAccessTestPage />} />
            <Route path="/upgrade" element={<Navigate to="/" state={{ scrollToPricing: true }} replace />} />
            <Route 
              path="/solver" 
              element={
                <ProtectedRoute requiredTier="basic">
                  <EcosystemSolverPage />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/batch" 
              element={
                <ProtectedRoute requiredTier="pro">
                  <EcosystemSolverPage batchMode={true} />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/analytics" 
              element={
                <ProtectedRoute requiredTier="pro">
                  <EcosystemSolverPage analyticsMode={true} />
                </ProtectedRoute>
              } 
            />
            
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
      </TrackProvider>
    </Router>
  );
}

export default App;
